module.exports = __webpack_public_path__ + "img/arrow-circle-right.48a5b922.svg";